export const GET_TECH_ASSIGNED_LIST = "GET_TECH_ASSIGNED_LIST";
export const GET_TECH_UNASSIGNED_LIST = "GET_TECH_UNASSIGNED_LIST";
export const GET_TECH_UNASSIGNED_COUNT = "GET_TECH_UNASSIGNED_COUNT";
export const GET_TECH_ASSIGNED_COUNT = "GET_TECH_ASSIGNED_COUNT";
export const GET_ZONE_LIST = "GET_ZONE_LIST";
